(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memio-announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('memio-announcements')) {
  customElements.define('memio-announcements', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const on = (node, event, fn) => node.addEventListener(event, fn, {signal:this.controller.signal});
      this.track = this.querySelector('.ma-track');
      this.items = [...this.querySelectorAll('.ma-item')];
      this.prev = this.querySelector('.ma-prev');
      this.next = this.querySelector('.ma-next');
      this.count = this.querySelector('.ma-count');
      this.index = 0; this.hovered = false; this.focused = false; this.editorPaused = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      on(this.prev,'click',()=>this.select(this.index-1,true));
      on(this.next,'click',()=>this.select(this.index+1,true));
      on(this,'mouseenter',()=>{this.hovered=this.dataset.hover==='true';this.sync();});
      on(this,'mouseleave',()=>{this.hovered=false;this.sync();});
      on(this,'focusin',()=>{this.focused=true;this.sync();});
      on(this,'focusout',()=>{queueMicrotask(()=>{if(this.isConnected){this.focused=this.contains(document.activeElement);this.sync();}});});
      on(document,'visibilitychange',()=>this.sync());
      on(this.reduced,'change',()=>this.build());
      on(document,'shopify:block:select',event=>{
        const index=this.items.findIndex(item=>item.dataset.block===event.detail.blockId);
        if(index<0)return;
        this.editorPaused=true;
        if(this.dataset.mode==='slider')this.select(index);
        else {this.animation?.pause();this.animation&&(this.animation.currentTime=0);this.querySelector('.ma-viewport').scrollLeft=this.items[index].offsetLeft-this.items[0].offsetLeft;}
        this.sync();
      });
      on(document,'shopify:block:deselect',()=>{this.editorPaused=false;this.querySelector('.ma-viewport').scrollLeft=0;this.sync();});
      if(this.dataset.mode==='scroll'){
        this.observer=new ResizeObserver(()=>this.build());
        this.observer.observe(this.querySelector('.ma-viewport'));
      }
      this.build();
    }
    disconnectedCallback(){
      this.controller?.abort();this.observer?.disconnect();this.animation?.cancel();clearInterval(this.timer);
    }
    select(index,announce=false){
      if(!this.items.length)return;
      this.index=(index+this.items.length)%this.items.length;
      this.items.forEach((item,i)=>{
        const active=i===this.index;
        item.classList.toggle('ma-active',active);
        item.inert=!active;
        item.setAttribute('aria-hidden',String(!active));
      });
      if(this.count)this.count.textContent=(this.index+1)+' / '+this.items.length;
      if(announce)this.querySelector('.ma-live').textContent=this.items[this.index].innerText;
      this.sync();
    }
    build(){
      this.animation?.cancel();
      this.animation=null;
      this.querySelectorAll('[data-clone]').forEach(node=>node.remove());
      this.classList.remove('ma-ready');
      this.prev.hidden=this.next.hidden=true;
      if(this.count)this.count.hidden=true;
      this.items.forEach(item=>{item.inert=false;item.removeAttribute('aria-hidden');});
      if(!this.items.length)return;
      if(this.dataset.mode==='slider'){
        this.classList.add('ma-ready');
        this.prev.hidden=this.next.hidden=this.items.length<2;
        if(this.count)this.count.hidden=this.items.length<2;
        this.select(this.index);
      }else if(!this.reduced.matches){
        this.classList.add('ma-ready');
        const gap=parseFloat(getComputedStyle(this.track).gap)||0;
        const distance=this.items.reduce((sum,item)=>sum+item.getBoundingClientRect().width+gap,0);
        if(distance<=0)return;
        const copies=Math.ceil(this.querySelector('.ma-viewport').clientWidth/distance)+1;
        for(let n=0;n<copies;n++)this.items.forEach(item=>{
          const clone=item.cloneNode(true);clone.dataset.clone='true';clone.removeAttribute('data-shopify-editor-block');clone.removeAttribute('data-block');
          clone.setAttribute('aria-hidden','true');clone.inert=true;
          clone.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          this.track.append(clone);
        });
        const reverse=this.dataset.direction==='right';
        this.animation=this.track.animate([{transform:'translateX('+(reverse?-distance:0)+'px)'},{transform:'translateX('+(reverse?0:-distance)+'px)'}],{duration:distance/Number(this.dataset.speed)*1000,iterations:Infinity,easing:'linear'});
      }
      this.sync();
    }
    sync(){
      clearInterval(this.timer);
      const paused=this.hovered||this.focused||this.editorPaused||document.hidden||this.reduced.matches;
      if(this.animation){if(paused)this.animation.pause();else this.animation.play();}
      if(this.dataset.mode==='slider'&&this.dataset.autoplay==='true'&&this.items.length>1&&!paused){
        this.timer=setInterval(()=>this.select(this.index+1),Number(this.dataset.interval)*1000);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memio-article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('memio-article')) {
    customElements.define('memio-article', class extends HTMLElement {
      connectedCallback() {
        const toc = this.querySelector('[data-memio-toc]');
        const list = this.querySelector('[data-memio-toc-list]');
        if (!toc || !list || this.dataset.ready) return;
        this.dataset.ready = 'true';
        const headings = [...this.querySelectorAll('[data-memio-body] h2')].filter(h => h.textContent.trim());
        if (!headings.length) { toc.hidden = true; return; }
        const fragment = document.createDocumentFragment();
        headings.forEach((heading, index) => {
          if (!heading.id || document.getElementById(heading.id) !== heading) {
            let id = `${this.id}-heading-${index + 1}`;
            while (document.getElementById(id)) id += '-x';
            heading.id = id;
          }
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          const item = document.createElement('li');
          item.append(link);
          fragment.append(item);
        });
        list.replaceChildren(fragment);
        toc.open = matchMedia('(min-width: 990px)').matches;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memio-category-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('memio-capacity')) {
    class MemioCapacity extends HTMLElement {
      connectedCallback() {
        this.changeHandler = (event) => {
          if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
          this.updateResults(Number(event.target.value));
        };
        this.addEventListener('change', this.changeHandler);
        this.setAttribute('ready', '');
        const selected = this.querySelector('input:checked');
        this.updateResults(Number(selected?.value || 1));
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.changeHandler);
      }

      updateResults(times) {
        if (!Number.isInteger(times) || times < 1 || times > 9) return;
        for (const result of this.querySelectorAll('[data-capacity]')) {
          const capacity = Number(result.dataset.capacity);
          const days = Math.floor(capacity / times);
          const remainder = capacity % times;
          result.querySelector('[data-days]').textContent = days === 1
            ? this.dataset.dayTemplate
            : this.dataset.daysTemplate.replace('__DAYS__', String(days));
          result.querySelector('[data-extra]').textContent = remainder === 0
            ? this.dataset.full
            : remainder === 1
              ? this.dataset.extraOne
              : this.dataset.extraTemplate.replace('__COUNT__', String(remainder));
        }
      }
    }
    customElements.define('memio-capacity', MemioCapacity);
  }

  } catch(e) { console.error(e); }
})();
})();
